<script>
  import { createEventDispatcher } from 'svelte';
  import Icon from '../../../Icon/Icon.svelte';
  import { subscriptionStatus } from '../../helper';
  export let options,
    componentInformationKeys,
    currentUserSubscriptionId,
    currentSubscription,
    upcomingSubscription,
    subscription;

  const dispatch = createEventDispatcher();

  const handleOfferTerms = (productMetaDataId) => dispatch('handleOfferTerms', productMetaDataId);
  const handleProductIdChange = (productMetaDataId) =>
    dispatch('handleProductIdChange', productMetaDataId);

  const hasCurrentFamilyProduct = subscription.products.some(
    (product) => product.metadataId === currentSubscription.metadataId
  );

  const hasUpcomingFamilyProduct = subscription.products.some(
    (product) => product.metadataId === upcomingSubscription.metadataId
  );

  const getSelectedOption = () => {
    if (hasUpcomingFamilyProduct) {
      return options.find((option) => option.id === upcomingSubscription.metadataId);
    } else if (hasCurrentFamilyProduct) {
      return options.find((option) => option.id === currentSubscription.metadataId);
    } else {
      return options[0];
    }
  };

  let selectedOption = getSelectedOption();
  let i = options.indexOf(selectedOption);
  $: index = i;

  const handleClick = (direction) => {
    if (direction === 'right') {
      if (options[i + 1]) {
        i += 1;
        handleOfferTerms(subscription.products[i].metadataId);
        handleProductIdChange(subscription.products[i].metadataId);
        return (selectedOption = options[i]);
      }
    } else {
      if (options[i - 1]) {
        i -= 1;
        handleOfferTerms(subscription.products[i].metadataId);
        handleProductIdChange(subscription.products[i].metadataId);
        return (selectedOption = options[i]);
      }
    }
  };

  const showSubscriptionStatus = (productId) => {
    handleProductIdChange(productId);
    return subscriptionStatus(
      productId,
      currentUserSubscriptionId,
      currentSubscription,
      componentInformationKeys,
      upcomingSubscription
    );
  };
</script>

<style lang="scss">
  @use './../styles/sharedStyles' as *;
  @use '../../index' as *;

  .ongoing {
    @include ongoing;
  }

  .selectable-products-wrapper {
    border-radius: 1rem;
    overflow: hidden;
    border: $orange-50 solid 0.1rem;

    .selectable-products {
      align-items: center;
      display: flex;
      justify-content: space-between;
      padding: spacing(1) spacing(2);
      min-height: spacing(8);

      .buttons-wrapper {
        display: flex;
        flex-direction: row;

        .circle {
          align-items: center;
          background: inherit;
          border: solid black 0.1rem;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          margin-inline-start: spacing(1);
          position: relative;
          width: spacing(4);
          height: spacing(4);

          &:hover {
            cursor: pointer;
          }
        }

        // needed for iphone safari
        .inner-circle {
          align-items: center;
          display: flex;
          justify-content: center;
        }

        .disableButton {
          border: solid #dcd5cd 0.1rem;

          &:hover {
            cursor: default;
          }
        }
      }

      .product-details {
        display: flex;
        flex-direction: column;

        .product-header {
          font-weight: 600;
          width: 110%;
        }

        .product-price {
          font-size: 1.6rem;
          font-weight: 500;

          :global(span) {
            color: $orange-50;
          }
        }
      }
    }
  }
</style>

<div class="selectable-products-wrapper">
  <div
    class={showSubscriptionStatus(selectedOption.id).class}
    class:ongoing={hasCurrentFamilyProduct || hasUpcomingFamilyProduct}
  >
    {showSubscriptionStatus(selectedOption.id).localisation}
    <!-- This is for keeping the height of the div -->
    {#if hasCurrentFamilyProduct || hasUpcomingFamilyProduct}
      <span>&nbsp;</span>
    {/if}
  </div>
  <div class="selectable-products">
    <div class="product-details">
      <label class="product-header" for={selectedOption.header}> {selectedOption.header} </label>
      <label for={selectedOption.subheader}>
        {selectedOption.subheader}
      </label>
      <label class="product-price" for={selectedOption.value}> {@html selectedOption.value} </label>
    </div>
    <div class="buttons-wrapper">
      <button class="circle" class:disableButton={index === 0} on:click={() => handleClick('left')}>
        <div class="inner-circle">
          <Icon iconName="minus" size="15" styles={{ fill: index === 0 ? '#dcd5cd' : 'black' }} />
        </div>
      </button>
      <button
        class="circle"
        class:disableButton={index === options.length - 1}
        on:click={() => handleClick('right')}
      >
        <div class="inner-circle">
          <Icon
            iconName="plus"
            size="15"
            styles={{ fill: index === options.length - 1 ? '#dcd5cd' : 'black' }}
          />
        </div>
      </button>
    </div>
  </div>
</div>
